import { cn } from "../../../../../utils/classnames";
import { getImageFocusStyle, IMAGE_FOCUS_CLASS } from "../../serviceImages";
import { GoldCtaLink } from "./GoldCtaLink";

/**
 * Darkens the bottom-left of the photo, where the copy sits, and fades out
 * towards the top-right so the picture still shows (values from Figma).
 */
const HERO_OVERLAY_CLASS =
  "tw:bg-[linear-gradient(13deg,rgba(0,0,0,0.55)_8.73%,rgba(0,0,0,0.55)_29.85%,rgba(102,102,102,0)_92.29%)]";

/**
 * The photo card that opens a tab: a darkened image with the tab's promise and
 * a single call to action sitting on top of it.
 *
 * `image` is a SERVICE_IMAGES entry ({ src, focusX, focusY }), `ctaTo` is an
 * in-app route; pass `isFullWidth` for a tab that has no side panel next to
 * the card (it is shorter and lets the copy run wider).
 */
export const ServiceHeroCard = ({
  image,
  eyebrow,
  title,
  description,
  ctaLabel,
  ctaTo,
  isFullWidth = false,
  className,
}) => (
  <div
    className={cn(
      "tw:relative tw:rounded-[8px] tw:overflow-hidden tw:flex tw:items-end",
      isFullWidth
        ? "tw:min-h-[420px] tw:lg:min-h-[450px]"
        : "tw:min-h-[460px] tw:lg:min-h-[518px]",
      className
    )}
  >
    <img
      src={image.src}
      alt={title}
      style={getImageFocusStyle(image)}
      className={cn(
        "tw:absolute tw:inset-0 tw:w-full tw:h-full tw:object-cover",
        IMAGE_FOCUS_CLASS
      )}
    />
    <div className={cn("tw:absolute tw:inset-0", HERO_OVERLAY_CLASS)} />

    <div
      className={cn(
        "tw:relative tw:z-10 tw:w-full tw:p-6 tw:lg:pl-12 tw:lg:pr-8",
        // Copy column from Figma: 614px (856px full width) plus the padding.
        isFullWidth
          ? "tw:lg:max-w-[936px] tw:lg:pb-12"
          : "tw:lg:max-w-[694px] tw:lg:pb-[52px]"
      )}
    >
      <div className="tw:font-hanken-grotesk tw:font-semibold tw:uppercase tw:tracking-[3px] tw:text-[10px] tw:leading-[14px] tw:text-[#C9C9C9]">
        {eyebrow}
      </div>

      <div className="tw:font-libre-caslon-display tw:font-normal tw:text-[#F6F6F6] tw:text-[30px] tw:lg:text-[42px] tw:leading-[40px] tw:lg:leading-[58px] tw:mt-3">
        {title}
      </div>

      <div className="tw:w-6 tw:h-px tw:bg-[#C9C9C9] tw:mt-8" />

      <div className="tw:font-hanken-grotesk tw:text-[#F6F6F6] tw:text-[14px] tw:lg:text-[15px] tw:leading-[20px] tw:lg:leading-[22px] tw:mt-8">
        {description}
      </div>

      <GoldCtaLink
        to={ctaTo}
        label={ctaLabel}
        className="tw:mt-8 tw:lg:mt-12 tw:lg:w-[420px]"
      />
    </div>
  </div>
);
